import React from 'react';
import {
    ManagerReferenceNodeContext,
    ManagerReferenceNodeSetterContext,
} from 'react-popper/lib/esm/Manager';

// Drop-in replacement for react-popper's Manager. It reuses the original
// contexts so Popper and Reference from the package keep working unchanged.
export function Manager({ children }) {
    const [referenceNode, setReferenceNode] = React.useState(null);
    const currentNode = React.useRef(null);
    const hasUnmounted = React.useRef(false);

    React.useEffect(
        () => () => {
            hasUnmounted.current = true;
        },
        [],
    );

    const handleSetReferenceNode = React.useCallback((node) => {
        // reactstrap's DropdownToggle builds a new ref callback on every render, so
        // React 19 detaches and re-attaches the ref on every single commit. Upstream
        // dispatches a state update for each of those calls; useState's own bail-out
        // does not apply mid-commit, so the Manager re-renders, which produces yet
        // another ref identity. A page with a handful of dropdowns then exhausts
        // React's shared 50-update budget and crashes with error #185, unmounting the
        // whole app. Guard on the node we already hold so each distinct reference node
        // costs exactly one update, and detaches (null) cost none.
        if (hasUnmounted.current || node == null || node === currentNode.current) {
            return;
        }
        currentNode.current = node;
        setReferenceNode(node);
    }, []);

    return (
        <ManagerReferenceNodeContext.Provider value={referenceNode}>
            <ManagerReferenceNodeSetterContext.Provider value={handleSetReferenceNode}>
                {children}
            </ManagerReferenceNodeSetterContext.Provider>
        </ManagerReferenceNodeContext.Provider>
    );
}
